import React, { FunctionComponent } from "react";
import Chart from "react-apexcharts";

import withChart from "./withChart";
import { ChartProps } from "@/@types/ui/Charts";

const BarChart: FunctionComponent<ChartProps> = (props) => {
  const { options, series, height, width } = props;

  return (
    <Chart
      type="bar"
      options={options}
      series={series}
      height={height || "800px"}
      width={width || undefined}
    />
  );
}

export default withChart(BarChart);
